import React, { useState } from "react";
import { OVERVIEW } from "../../../core/theme/reportTheme";

// Localhost only: copies the exact result the page draws (what the MCP will return).
export default function CopyResultButton({ result }) {
  const [copied, setCopied] = useState(false);
  const isLocal = typeof window !== "undefined" && window.location.hostname === "localhost";
  if (!isLocal) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(result, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error("Copy result JSON failed", e);
    }
  };

  return <button type="button" onClick={copy} className={OVERVIEW.devButton}>{copied ? "Copied" : "Copy result JSON"}</button>;
}
